import { isArray } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { useDisclosure } from '@mantine/hooks'
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  ProgressBar,
  Tooltip
} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useHistory } from 'react-router-dom'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { useForm } from 'react-hook-form'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import { revelarEnviarSms } from '../../../redux/actions/index'
import { logout } from '../../../services/auth'
import {
  elipseVerde,
  exclamacao,
  fecharJanela,
  lixeiraVermelho,
  setaDropdown
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import utilsSms from '../../../utils/sms'
import { validatePhones } from '../../../utils/validarTelefones'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SelectTemplateSms from '../../componentesModais/selects/selectTemplateSms'
import Alerta from './Alerta'

const valorLimite = 50

const MENSAGENS = {
  naoPossuiContaSms: {
    titulo: 'Atenção',
    mensagem:
      'Não é possível enviar mensagens pois seu usuário não possui conta SMS ativa.'
  },
  somenteNeoClaro: {
    titulo: 'Atenção',
    mensagem:
      'Só é possível enviar mensagens para linhas NEO Claro pois seu usuário não possui conta SMS ativa.'
  },
  limiteSimcards: {
    titulo: 'Atenção',
    mensagem:
      'Todas as linhas foram removidas. A quantidade de SIM cards deve ser entre 1 e 50.'
  }
}

const iconeAlerta = (
  <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
)

const CODIGOS_OPERADORA_NEO_CLARO = '89,93,95'

export default function SmsEnviar({
  itensSelecionados,
  renderizar,
  setRenderizar
}) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const history = useHistory()
  const [openedAlerta, { open: openAlerta, close: closeAlerta }] =
    useDisclosure(false)
  const [linhaRemover, setLinhaRemover] = useState('')
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [switchHabilitarResposta, setSwitchHabilitarResposta] = useState(false)
  const [dsMensagem, setDsMensagem] = useState('')
  const [saldoDisponivel, setSaldoDisponivel] = useState(0)
  const [creditosNecessarios, setCreditosNecessarios] = useState(0)
  const [caracteresMensagem, setCaracteresMensagem] = useState(120)
  const [dsTemplateSms, setDsTemplateSms] = useState('Selecione')
  const [revelarSelectTemplateSms, setRevelarSelectTemplateSms] =
    useState(false)
  const [mensagemAtencao, setMensagemAtencao] = useState(null)
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [itens, setItens] = useState([])
  const [simcardsLinhas, setSimcardsLinhas] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [carregandoValidacao, setCarregandoValidacao] = useState(true)
  const [invalidSimcards, setInvalidSimcards] = useState([])

  const userHasSMS = decryptJWT('userHasSMS')

  const { register, handleSubmit, errors } = useForm()

  const despacho = useDispatch()
  const modal = useRef()

  const cdSmsContaUsuario = utilsSms.getCdSmsContaUsuario()

  let modoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )

  const { data: dataNeoClaro, isFetching: isSuccessNeoClaro } = useQuery(
    'validarSimcardsNeoClaroDispositivos',
    async () => {
      const params = {
        busca: '',
        ordenador: '',
        filtro: JSON.stringify({ OPERADORA: CODIGOS_OPERADORA_NEO_CLARO }),
        contar: true,
        buscaArquivo: JSON.stringify({})
      }

      const response = await api_gateway.get('/api/v2/devices/simcard', {
        params
      })

      return response.data?.devices
    },
    {
      enabled: !userHasSMS,
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  useQuery(
    'carregarSaldoSmsDispositivos',
    async () => {
      const query = utilsSms.getNewQueryGet('paginaAtual=0&carregarLimit=1')
      const response = await api_gateway.get(
        `/m1/consultar/smsExtrato?${query}`
      )

      if (
        response.data.status === 200 &&
        response.data.dados[0] !== undefined
      ) {
        return response.data.dados[0].n0_saldo_real
      } else {
        return 0
      }
    },
    {
      onSuccess: (saldo) => {
        setSaldoDisponivel(saldo)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  )

  useEffect(() => {
    setSpinAtivo(true)
    async function preencherTabela() {
      if (modoSelecaoSimcard || itensSelecionados.length > 50) {
        setMensagemAtencao(MENSAGENS.limiteSimcards)
      } else {
        setItens(itensSelecionados)
        handleLinhasSimcards(itensSelecionados)
      }
      setSpinAtivo(false)
    }
    preencherTabela()

    validateSms(itensSelecionados.map((item) => item.CALLERID).join(';'))
  }, [])

  useEffect(() => {
    if (!userHasSMS && !isSuccessNeoClaro) {
      const quantidade = dataNeoClaro?.length || 0

      if (quantidade > 1) {
        setMensagemAtencao(MENSAGENS.somenteNeoClaro)
      } else {
        setMensagemAtencao(MENSAGENS.naoPossuiContaSms)
      }

      setCarregandoValidacao(false)
    } else if (userHasSMS) {
      setCarregandoValidacao(false)
    }
  }, [userHasSMS, isSuccessNeoClaro])

  const colunas = [
    {
      dataField: 'CD_SIMCARD',
      text: 'Código',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'OPERADORA',
      text: 'Operadora',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'CALLERID',
      headerClasses: 'nao-selecionavel',
      text: 'Linha',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ICCID',
      headerClasses: 'nao-selecionavel',
      text: 'ICCID',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'PLANO',
      headerClasses: 'nao-selecionavel',
      text: 'Plano',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell} MB</p>
      }
    },
    {
      dataField: 'CONSUMO_PERCENTUAL',
      text: 'Consumo (%)',
      headerClasses: 'centralizar nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        let styleProgressBar = ''
        if (!cell || cell == '') cell = 0

        styleProgressBar = '#36D896'

        return (
          <ProgressBar className="barra-progresso-container">
            <ProgressBar
              style={{ backgroundColor: styleProgressBar }}
              now={cell}
            />
            <span className="texto-barra-progresso fonte-cor-1">
              {cell === undefined ? '0.00%' : cell.toFixed(2) + '%'}
            </span>
          </ProgressBar>
        )
      }
    },
    {
      dataField: 'ULTIMO_EVENTO',
      headerClasses: 'nao-selecionavel',
      text: 'Último evento',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'acoes',
      text: '',
      sort: false,
      headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
      formatter: () => {
        return (
          <Button
            variant="danger"
            className="botoes-tabela-acoes"
            size="sm"
            onClick={() => handleMensagemAtencao(false)}
          >
            <img
              className="icone-botao-acao-tabela"
              src={lixeiraVermelho()}
              alt="remover-linha"
            />
          </Button>
        )
      }
    }
  ]

  const validateSms = async (phones, smsTipo = 1) => {
    api_gateway
      .post('/m1/consultar/validadorSms', {
        lista_callerIds: phones.split(';'),
        cd_sms_tipo: smsTipo
      })
      .then((response) => {
        if (response.data.status === 200) {
          setCreditosNecessarios(response.data.neededCredits)
        } else {
          setCreditosNecessarios(0)
        }
      })
      .catch((err) => {
        console.error(err)
        setCreditosNecessarios(0)
      })
      .finally(() => {
        setSpinAtivo(false)
      })
  }

  const handleCreditosGastos = async () => {
    const habilitarResposta = !switchHabilitarResposta
    setSwitchHabilitarResposta(habilitarResposta)

    const validPhones = validatePhones(
      itens.length > 0
        ? itens.map((item) => item.CALLERID).join(';')
        : simcardsLinhas
    )

    if (validPhones && validPhones !== '') {
      setSpinAtivo(true)
      await validateSms(validPhones, habilitarResposta ? 2 : 1)
    } else {
      setCreditosNecessarios(0)
    }
  }

  const eventosLinhas = {
    onClick: (e, row) => {
      setLinhaRemover(row.CD_SIMCARD)
    }
  }

  function handleMotivo(motivo) {
    setDsMensagem(motivo)
    setCaracteresMensagem(120 - motivo.length)
  }

  async function handleRemoverLinha(CD_SIMCARD) {
    ColetaClickstream(1135) // enviarSMSRemoverLinha
    setRevelarMensagemAtencao(false)

    const itensAtualizados = itens.filter(
      (item) => item.CD_SIMCARD !== CD_SIMCARD
    )

    const callerIds = itensAtualizados.map((item) => item.CALLERID)

    setSimcardsLinhas(callerIds)
    setItens(itensAtualizados)
    validateSms(callerIds.join(';'))
  }

  async function handleEnviar() {
    ColetaClickstream(1137) // enviarSMSEnviar
    setSpinAtivo(true)

    const bodyEnviarSms = utilsSms.getNewBodyPost({
      lista_callerIds: simcardsLinhas,
      ds_mensagem: dsMensagem,
      cd_sms_tipo: switchHabilitarResposta == true ? 2 : 1,
      cd_sms_conta_usuario_created: cdSmsContaUsuario
    })

    await api_gateway
      .post('/m1/cadastrar/smsEnvio', bodyEnviarSms)
      .then(() => {
        setRevelarMensagemSucesso(true)
      })
      .catch((error) => {
        const response = error?.response?.data
        const invalidSimcards = response?.invalidSimcards

        let mensagem = response?.info

        if (mensagem === 'Excedeu o limite de envios!') {
          setMensagemErro(
            'Seu acesso foi bloqueado por exceder o limite mensal de envios de SMS. Entre em contato com o suporte técnico para mais informações.'
          )

          openAlerta()
          return
        } else if (isArray(invalidSimcards) && invalidSimcards.length > 0) {
          mensagem = response?.message
          setInvalidSimcards(invalidSimcards)
        }

        setMensagemErro(mensagem)
        openAlerta()
      })
      .finally(() => {
        setSpinAtivo(false)
      })
  }

  const handleCloseAlert = () => {
    closeAlerta()

    if (mensagemErro.includes('Seu acesso foi bloqueado')) {
      logout()
      history.push('/login')
    }
  }

  async function handleCancelar() {
    ColetaClickstream(1136) // enviarSMSCancelar
    setSpinAtivo(false)
    despacho(revelarEnviarSms(false))
  }

  function handleLinhasSimcards(consultaSimcards) {
    let tempLinhas = []
    for (let i = 0; i < consultaSimcards.length; i++) {
      tempLinhas.push(consultaSimcards[i].CALLERID)
    }
    setSimcardsLinhas(tempLinhas)
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      if (confirmacao === true) {
        handleRemoverLinha(linhaRemover)
      }
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
    }
    if (confirmacao) {
      setRenderizar(!renderizar)
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  if (carregandoValidacao) return null

  if (mensagemAtencao) {
    const handleFecharMensagemAtencao = () => {
      if (
        mensagemAtencao === MENSAGENS.naoPossuiContaSms ||
        mensagemAtencao === MENSAGENS.limiteSimcards
      ) {
        handleCancelar()
      } else {
        const itensFiltrados = itensSelecionados.filter((itemSelecionado) =>
          dataNeoClaro.some(
            (itemPermitido) =>
              itemPermitido.CD_SIMCARD === itemSelecionado.CD_SIMCARD
          )
        )

        if (itensFiltrados.length === 0) {
          handleCancelar()
          return
        }

        setItens(itensFiltrados)
        handleLinhasSimcards(itensFiltrados)
        validateSms(itensFiltrados.map((item) => item.CALLERID).join(';'))

        setMensagemAtencao(null)
      }
    }

    return (
      <div ref={modal} className="componente-modal-overlay">
        <div className="componente-modal">
          <MensagemAtencao
            handleMensagemAtencao={handleFecharMensagemAtencao}
            mensagemTitulo={mensagemAtencao.titulo}
            mensagemParagrafo1={mensagemAtencao.mensagem}
            mensagemBotao="Fechar"
            semBotaoCancelar
          />
        </div>
      </div>
    )
  }

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleEnviar())}>
      <div className="modal-acao-enviar-sms fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Enviar SMS</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="container-tabela-modal">
              <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                {({ paginationTableProps }) => (
                  <>
                    <BootstrapTable
                      classes="tabela-transparente-modais"
                      condensed
                      keyField="CD_SIMCARD"
                      data={itens}
                      columns={colunas}
                      rowEvents={eventosLinhas}
                      noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                      bootstrap4
                      {...paginationTableProps}
                    />
                  </>
                )}
              </PaginationProvider>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
              {itens?.length} linhas selecionadas
            </span>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="grupo-enviar-sms-1">
              <div className="coluna-painel-sms-enviar-sms-1">
                <div className="container-switch-cancelamento-reposicao">
                  <div className="flipswitch">
                    <input
                      type="checkbox"
                      name="flipswitch"
                      className="flipswitch-cb"
                      id="permitirConfirmacao"
                      onChange={() => handleCreditosGastos()}
                    />
                    <label
                      className="flipswitch-label"
                      htmlFor="permitirConfirmacao"
                    >
                      <div className="flipswitch-inner flipswitch-cor-1" />
                      <div className="flipswitch-switch" />
                    </label>
                  </div>
                  <div className="fonte-cor-1 label-normal label-termos-cancelamento-reposicao-1">
                    {' '}
                    Habilitar resposta
                  </div>
                </div>
              </div>
              <div className="coluna-enviar-sms-3">
                <Form.Label>
                  <div className="fonte-cor-1 label-campo">Template</div>
                </Form.Label>
                {revelarSelectTemplateSms === false && (
                  <Button
                    name="cdTemplateSms"
                    className="campo-texto-cor-3 campo-select"
                    onClick={() =>
                      setRevelarSelectTemplateSms(!revelarSelectTemplateSms)
                    }
                  >
                    <div className="fonte-cor-1 label-campo">
                      {dsTemplateSms}
                    </div>
                    <img
                      className={
                        revelarSelectTemplateSms
                          ? 'campo-select-icone-ativado nao-selecionavel'
                          : 'campo-select-icone-desativado nao-selecionavel'
                      }
                      src={setaDropdown()}
                      alt="drop"
                    />
                  </Button>
                )}
                {revelarSelectTemplateSms === true && (
                  <SelectTemplateSms
                    setRevelarSelectTemplateSms={setRevelarSelectTemplateSms}
                    setDsMensagem={setDsMensagem}
                    setDsTemplateSms={setDsTemplateSms}
                    dsTemplateSms={dsTemplateSms}
                    cd_sms_conta_usuario={cdSmsContaUsuario}
                  />
                )}
              </div>
              <div className="coluna-painel-sms-enviar-sms-3">
                <div className="grupo-painel-sms-enviar-sms-2">
                  <div>
                    <span className="label-valor-cancelamento-reposicao-1 fonte-cor-1 negrito">
                      Créditos necessários:{' '}
                    </span>
                    <span className="label-valor-cancelamento-reposicao-2 fonte-cor-3 negrito">
                      {creditosNecessarios}
                    </span>
                  </div>
                  <div>
                    <span className="label-valor-cancelamento-reposicao-1 fonte-cor-1 negrito">
                      Créditos disponíveis:{' '}
                    </span>
                    <span className="label-valor-cancelamento-reposicao-2 fonte-cor-2 negrito">
                      {saldoDisponivel}{' '}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Mensagem</div>
              </Form.Label>
              <OverlayTrigger
                delay={{ show: 500, hide: 250 }}
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-bottom">Digite sua mensagem</Tooltip>
                }
              >
                <Form.Control
                  name="dsMensagem"
                  value={dsMensagem}
                  className="campo-texto-cor-3 campo-texto-area"
                  as="textarea"
                  placeholder="Digite sua mensagem"
                  rows="3"
                  onChange={(e) => handleMotivo(e.target.value)}
                  ref={register({ required: true })}
                  maxlength="120"
                />
              </OverlayTrigger>
              {errors.titulo && (
                <p className="texto-campo-obrigatorio">
                  {iconeAlerta} O campo é obrigatorio.
                </p>
              )}
              <Form.Label className="contador-carateres-restantes">
                <div className="fonte-cor-1 label-normal">
                  {caracteresMensagem} caracteres restantes
                </div>
              </Form.Label>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Button
              disabled={!dsMensagem}
              type="submit"
              className="botao-confirmar"
              variant="success"
              size="sm"
              onKeyPress={(e) => {
                e.key === 'Enter' && e.preventDefault()
              }}
            >
              <div className="fonte-cor-4">Confirmar</div>
            </Button>
            <Button
              className="botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar()}
            >
              <div className="fonte-cor-2">Cancelar</div>
            </Button>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="SMS Enviado."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro!"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Remover linha?"
              mensagemBotao="Remover"
            />
          </div>
        </div>
      )}
      {openedAlerta && (
        <Alerta
          opened={openedAlerta}
          onClick={handleCloseAlert}
          message={mensagemErro}
          invalidSimcards={invalidSimcards}
        />
      )}
    </Form>
  )
}
